import React from "react";
// import PropTypes from "prop-types";
import { InputField } from "@components/Input";
import styles from "./styles/Question.module.css";

const SingleLineQuestion = (props) => {
  const { userAnswer, onChange, correctAnswer, isCorrect, showAnswer } = props;
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <div className="">
      <InputField
        placeholder={!showAnswer && "Type your answer..."}
        value={userAnswer[0]}
        onChange={(e) => onChange([e.target.value])}
        readonly={showAnswer}
        className={styles.option}
      />
      {showAnswer && !isCorrect && (
        <p className="mt-2">
          <b>Answer: {correctAnswer}</b>
        </p>
      )}
    </div>
  );
};

/* required: display name */
SingleLineQuestion.displayName = "SingleLineQuestion";

/* required: props types */
SingleLineQuestion.propTypes = {};

/* required: default props */
SingleLineQuestion.defaultProps = {};

export { SingleLineQuestion };
